import { Phone } from "lucide-react";
import { telHref, waHref } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const MobileCtaBar = () => (
  <div
    data-testid="mobile-sticky-cta"
    className="fixed inset-x-0 bottom-0 z-50 md:hidden"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <div className="grid grid-cols-2 shadow-[0_-8px_30px_rgba(0,0,0,0.3)]">
      <a
        href={telHref}
        data-testid="sticky-call-button"
        onClick={() => trackEvent("phone_click", "mobile_sticky")}
        className="flex min-h-[56px] items-center justify-center gap-2 bg-brand px-4 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors active:bg-brand-dark"
      >
        <Phone className="h-5 w-5" aria-hidden="true" />
        Ara
      </a>
      <a
        href={waHref()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
        onClick={() => trackEvent("whatsapp_location_click", "mobile_sticky")}
        className="flex min-h-[56px] items-center justify-center gap-2 bg-wa px-4 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors active:bg-wa-dark"
      >
        <WhatsAppIcon className="h-5 w-5" />
        WhatsApp
      </a>
    </div>
  </div>
);
